"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaceholderStyles = void 0;
var react_1 = require("@emotion/react");
var placeHolderStyles = {
    centeredWithIcon: (0, react_1.css)({
        minWidth: 80,
        maxWidth: 100,
        width: '30%',
    }),
    leftAlignedWithIcon: (0, react_1.css)({
        width: 45,
    }),
    centeredWithoutIcon: (0, react_1.css)({
        width: 57,
    }),
};
var getPlaceholderStyles = function (isTextCentered, isIconPresent) {
    return isIconPresent
        ? isTextCentered
            ? placeHolderStyles.centeredWithIcon
            : placeHolderStyles.leftAlignedWithIcon
        : placeHolderStyles.centeredWithoutIcon;
};
exports.getPlaceholderStyles = getPlaceholderStyles;
var makeCheckBoxStyling = function (smallIcon, minHeight) {
    var _a, _b;
    var _c = (0, react_1.useTheme)(), breakpoints = _c.breakpoints, mvf = _c.mvf;
    var spacing = mvf.spacing, fontSize = mvf.fontSize;
    return {
        checkbox: (0, react_1.css)({
            '&.MuiCheckbox-root': (_a = {
                    paddingLeft: 11,
                    paddingRight: 11
                },
                _a[breakpoints.up('tabletSmall')] = {
                    marginLeft: 11,
                },
                _a),
        }),
        checkboxContainerRight: (0, react_1.css)({
            right: 10,
            position: 'absolute',
        }),
        grid: (0, react_1.css)({
            height: '100%',
            width: '100%',
            minHeight: minHeight ? minHeight : 48,
        }),
        centerIcon: (0, react_1.css)({
            marginTop: 9,
            marginBottom: 9,
            width: '100%',
            '& img': {
                height: 40,
            },
        }),
        leftIcon: (0, react_1.css)({
            marginTop: smallIcon ? 14 : 9,
            marginBottom: smallIcon ? 14 : 9,
            marginLeft: 'clamp(5px, 2%, 10px)',
            minWidth: smallIcon ? 60 : 80,
            maxWidth: 100,
            width: smallIcon ? '20%' : '30%',
            '& img': {
                height: smallIcon ? 30 : 40,
            },
        }),
        imgDiv: (0, react_1.css)({
            display: 'flex',
            justifyContent: 'center',
        }),
        innerGrid: (0, react_1.css)({
            flexWrap: 'nowrap',
        }),
        textGrid: (0, react_1.css)({
            overflowWrap: 'anywhere',
            wordBreak: 'normal',
            justifyContent: 'flex-start',
            flex: 1,
        }),
        otherInput: (0, react_1.css)({
            marginTop: -1,
            padding: spacing.tiny,
            '& .MuiInputBase-root input': (_b = {
                    textAlign: 'left',
                    fontSize: fontSize.mini
                },
                _b[breakpoints.up('mobileMedium')] = {
                    fontSize: fontSize.small,
                },
                _b[breakpoints.up('tabletSmall')] = {
                    fontSize: fontSize.compact,
                },
                _b),
        }),
    };
};
exports.default = makeCheckBoxStyling;
//# sourceMappingURL=makeCheckBoxStyling.js.map